import React, { forwardRef } from 'react';
import Select from 'react-select';

const CustomSelect = forwardRef(({
  options,
  handleChange,
  w = '100%',
  placeholder = 'Select...',
  val 

}, ref) => {
  return (
      <Select
      ref={ref}
      isLoading={options ? false : true}
      placeholder={placeholder}
      isSearchable={true}
      name="customSelect"
      options={options}
      onChange={handleChange}
      value={val}
      getOptionValue={(option) => option.id}
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          width: w
        }),
        container: (base) => ({
          ...base,
          width: '100%' // fuerza el contenedor general a ocupar todo
        })
      }}
    />
  );
});

export default CustomSelect;
